export default "__VITE_ASSET__VsfO5HHWVEbGV_iPcQpuog__"